const focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    '[tabindex]',
    '[contentEditable=true]',
]
    .map((selector) => `${selector}:not([tabindex="-1"])`)
    .join(',');

export const ESCAPE_KEY = 27;
export const TAB_KEY = 9;

export function getFocusableElements(container: HTMLElement | null) {
    if (container == null) {
        return [];
    }
    return Array.from(container.querySelectorAll<HTMLElement>(focusableSelector));
}

export function containerSortedFocusableElements(container: HTMLElement | null) {
    const focusableElements = getFocusableElements(container);

    return focusableElements.slice().sort((aItem, zItem) => {
        const position = aItem.compareDocumentPosition(zItem);

        if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return -1;
        }
        if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return 1;
        }

        return 0;
    });
}

// Bound in the capture phase, so the radio group's own arrow handling, which chooses as it moves, never runs.
export function moveRadioFocus(event: KeyboardEvent, step: number): void {
    const group = event.currentTarget as HTMLElement;
    const radios = Array.from(group.querySelectorAll<HTMLElement>('[role="radio"]:not([aria-disabled="true"])'));
    const index = radios.indexOf(event.target as HTMLElement);

    if (-1 === index) {
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    radios[(index + step + radios.length) % radios.length]?.focus();
}

export function keepAnchorDefaultBehavior(event: MouseEvent | KeyboardEvent): boolean {
    return Boolean(
        event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            ((<MouseEvent>event).button && (<MouseEvent>event).button !== 0)
    );
}
